import { NavLink } from 'react-router-dom';

import SectionNavigation from '../../components/SectionNavigation';

const TolerancesHeader = () => (
  <SectionNavigation ariaLabel="Tolerances navigation">
    <NavLink to="/tolerances/limit-deviations">Limit Deviations</NavLink>
    <NavLink to="/tolerances/fits">Fit Calculator</NavLink>
    <NavLink to="/tolerances/fit-finder">Fit Finder</NavLink>
    <NavLink to="/tolerances/recommended-fits">Recommended Fits</NavLink>
    <NavLink to="/tolerances/gauges">Gauges</NavLink>
    <NavLink to="/tolerances/reamer-calculator">Reamer Calculator</NavLink>
  </SectionNavigation>
);

export default TolerancesHeader;
